import { render, staticRenderFns } from "./FeedbackSelector.vue?vue&type=template&id=0349bc52&scoped=true"
import script from "./FeedbackSelector.vue?vue&type=script&lang=js"
export * from "./FeedbackSelector.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSelector.vue?vue&type=style&index=0&id=0349bc52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349bc52",
  null
  
)

export default component.exports